import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Store, Package, ClipboardList, BarChart3, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicLayout from "@/components/public/PublicLayout";
import Seo from "@/components/public/Seo";
import { PageHero, SectionHead } from "@/components/public/blocks";

export default function Sell() {
  const { t } = useTranslation();
  const features = [
    { icon: Store, title: t("site.sell.f1t"), body: t("site.sell.f1b") },
    { icon: Package, title: t("site.sell.f2t"), body: t("site.sell.f2b") },
    { icon: ClipboardList, title: t("site.sell.f3t"), body: t("site.sell.f3b") },
    { icon: BarChart3, title: t("site.sell.f4t"), body: t("site.sell.f4b") },
  ];
  const steps = [t("site.sell.st1"), t("site.sell.st2"), t("site.sell.st3")];
  return (
    <PublicLayout testId="sell-page">
      <Seo path="/sell" title={t("site.seo.sellTitle")} description={t("site.seo.sellDesc")} />
      <PageHero badge={t("site.nav.sell")} title={t("site.sell.title")} subtitle={t("site.sell.subtitle")}>
        <Link to="/register?role=merchant" data-testid="sell-register-btn" className="inline-block mt-8">
          <Button size="lg" className="bg-brand hover:bg-brand-dark rounded-full h-12 px-7 text-base gap-2">{t("site.sell.cta")} <ArrowRight className="w-4 h-4 rtl:rotate-180" aria-hidden="true" /></Button>
        </Link>
      </PageHero>
      <section className="max-w-7xl mx-auto px-5 pb-20">
        <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => (
            <li key={f.title} className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <f.icon className="w-6 h-6 text-brand" aria-hidden="true" />
              <h3 className="font-display font-bold text-lg mt-3">{f.title}</h3>
              <p className="text-sm text-slate-400 mt-2">{f.body}</p>
            </li>
          ))}
        </ul>
      </section>
      <section className="max-w-7xl mx-auto px-5 py-20 border-t border-white/10">
        <SectionHead title={t("site.sell.stepsTitle")} />
        <ol className="grid gap-4 md:grid-cols-3">
          {steps.map((s, i) => (
            <li key={s} className="rounded-2xl border border-white/10 p-6 flex gap-4" data-testid={`sell-step-${i + 1}`}>
              <span className="w-9 h-9 shrink-0 rounded-full bg-brand text-white font-mono flex items-center justify-center">{i + 1}</span>
              <p className="text-slate-300">{s}</p>
            </li>
          ))}
        </ol>
        <p className="text-sm text-slate-500 mt-8">{t("site.sell.note")}</p>
      </section>
    </PublicLayout>
  );
}
